import React from 'react';
import { css, cx } from 'emotion';
import IconPattern from './IconPattern';

const IconEasyBoat = (props) =>{
    return(
      <IconPattern size={props.size}>
        <svg
        className={css`
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
            `}
          version="1.1" viewBox="0 0 384 384">
            <path fill={props.color} d="M216,120a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16H216Z"/>
            <path fill={props.color} d="M136,120a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16H136Z"/>
            <path fill={props.color}  d="M224,72a8,8,0,0,0-8-8H168a8,8,0,0,0-8,8v8h64V72Z"/>
            <path fill={props.color} d="M120,112a8,8,0,0,1,8-8H256a8,8,0,0,1,8,8v54.12l16,5V112a24,24,0,0,0-24-24H128a24,24,0,0,0-24,24v59.12l16-5V112Z"/>
            <path fill={props.color}  d="M114.87,293.74c1-.68,2.17-1.52,3.53-2.54a64.29,64.29,0,0,1,9.89-6.41L86.72,201.66,192,168.76l105.28,32.9-41.57,83.13a64.34,64.34,0,0,1,9.88,6.41c1.36,1,2.49,1.86,3.54,2.54l46.67-93.33A8,8,0,0,0,311,189.2L192,152,73,189.2a8,8,0,0,0-4.77,11.21Z"/>
            <path fill={props.color} d="M293.86,297.6c-5,3.72-8.53,6.4-16.54,6.4s-11.58-2.68-16.54-6.4c-5.7-4.28-12.8-9.6-26.14-9.6s-20.43,5.32-26.13,9.6c-5,3.72-8.53,6.4-16.53,6.4s-11.58-2.68-16.53-6.4c-5.7-4.28-12.8-9.6-26.13-9.6s-20.43,5.32-26.13,9.6c-5,3.72-8.53,6.4-16.53,6.4s-11.58-2.68-16.53-6.4c-5.7-4.28-12.8-9.6-26.13-9.6v16c8,0,11.58,2.68,16.53,6.4,5.7,4.28,12.8,9.6,26.13,9.6s20.43-5.32,26.13-9.6c5-3.72,8.53-6.4,16.53-6.4s11.58,2.68,16.53,6.4c5.7,4.28,12.8,9.6,26.13,9.6s20.43-5.32,26.13-9.6c5-3.72,8.53-6.4,16.53-6.4s11.58,2.68,16.54,6.4c5.7,4.28,12.8,9.6,26.13,9.6s20.43-5.32,26.14-9.6c5-3.72,8.53-6.4,16.54-6.4V288C306.67,288,299.57,293.32,293.86,297.6Z"/>
        </svg>
    </IconPattern>
    )
}

export default IconEasyBoat;
